import React, { useState, useCallback } from 'react';
import styled from '@emotion/styled';
import { withMultiScreenReceiver } from '../hooks/useMultiScreenReceiver';

const PresentationDebugScreenBackground = styled.div({
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '20vw',
    height: '20vh',
    color: 'white',
    fontSize: 'large',
    backgroundColor: 'rgb(1, 1, 1, 0.4)',
    overflowY: 'scroll',
});

function PresentationDebugScreen() {
    const [items, setItems] = useState<unknown[][]>([]);

    window.console.log = useCallback(() => (...args: unknown[]) => {
        setItems([...items, ['log', ...args]]);
    }, [items])();

    window.console.error = useCallback(() => (...args: unknown[]) => {
        setItems([...items, ['error', ...args]]);
    }, [items])();

    window.console.info = useCallback(() => (...args: unknown[]) => {
        setItems([...items, ['info', ...args]]);
    }, [items])();

    window.console.warn = useCallback(() => (...args: unknown[]) => {
        setItems([...items, ['warn', ...args]]);
    }, [items])();

    window.console.debug = useCallback(() => (...args: unknown[]) => {
        setItems([...items, ['debug', ...args]]);
    }, [items])();

    return (
        <PresentationDebugScreenBackground>
            {
                items.map((item, idx) =>
                    <div key={idx}>{(() => {
                        const [, ...args] = item;
                        return args.map(x => `${JSON.stringify(x)}`).join(', ');
                    })()
                    }</div>)
            }
        </PresentationDebugScreenBackground>
    );
}

const enablePresentationDebugScreen = false;

export type ReceiverProps = {
    presentationReceiver: PresentationReceiver;
}

export function Receiver(props: React.PropsWithChildren<ReceiverProps>) {
    const { presentationReceiver, children } = props;

    return (
        withMultiScreenReceiver(presentationReceiver)(
            <React.Fragment>
                {children}
                {
                    enablePresentationDebugScreen
                        ? <PresentationDebugScreen />
                        : <React.Fragment />
                }
            </React.Fragment>
        )
    );
}
